
import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { useState } from 'react';
import { setErrorMessage, setMessage, clearMessage, setHTMLMessage } from "../tools/errorhandling";
import { myData, getemployers, saveEmailMessage, getEmailMessage, updateEmailMessage,sendEmailMessage } from "../dbconnector/connector";
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import { VscSend } from "react-icons/vsc";
import { AiOutlineSave } from "react-icons/ai";
import { useParams } from "react-router-dom";
import Quill from "quill";


const Composeemailmessage = (props) => {


    const t = props.translation
    let { id } = useParams();
    const [user, setUser] = useState({});
    const [employers, setEmployers] = useState({});
    const [employer, setEmployer] = useState({});
    const [employersArray, setemployersArray] = useState([]);
    const [selectedmessage, setSelectedMessage] = useState({})
    //t("CheckIn")
    // create navigation object if needed
    const navigate = useNavigate();
    const theme = 'snow';
    // const theme = 'bubble';

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ align: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],

            ['link', 'image'],
            [{ color: [] }, { background: [] }],
        ],
    };

    const placeholder = 'Geef je text en opmaak in';

    const formats = ['bold', 'italic', 'underline', 'strike',
        'align', 'list', 'indent',
        'size', 'header',
        'link', 'image', 'video',
        'color', 'background','script','bullet',];

    const { quill, quillRef } = useQuill({ theme, modules, formats, placeholder });

    //dop something after loading page
    useEffect(() => {

        getMyData()
        LoadEmployers();

    }, []);
    useEffect(() => {

        if (id !== "null") {
            getMessage(id)
        }
        else
             createEmptyMessage()

    }, [id]);

    useEffect(() => {
        if (quill !== undefined) {
            if (selectedmessage.message !== undefined) {
                const value = selectedmessage.message
                const delta = quill.clipboard.convert({ html: value })
                quill.setContents(delta, 'silent')
            } else {
                quill.root.innerHTML = 'Geef je text en opmaak in'
            }
        }
    }, [selectedmessage]);

    const createEmptyMessage = () => {
        setEmployer(0)
    }

    const getMyData = async () => {
        myData().then(res => {
            if (res) {
                setUser({ ...res })
            }
        })
    }

    const LoadEmployers = () => {
        try {
            getemployers(true).then((res) => {
                if (res.status === 200) {

                    res.items.forEach((item, index) => {
                        setEmployers(prevState => { return { ...prevState, [item.id]: { item } } })
                    })
                } else {
                    setErrorMessage(res.status + ": " + res.message)
                }
            })
        } catch (error) {
            setErrorMessage(t("error_canotgetuserlist"))
        }
    }
    useEffect(() => {
        if (Object.keys(employers).length > 0) {
            const options = Object.keys(employers).map((key) => {
                const emp = employers[key].item;
                return { value: key, label: `${emp.Naam}` };
            })
            options.unshift({ value: "", label: t('Kies een werknemer') })
            setemployersArray(options)
        }
    }, [employers]);
    const navigateback = () => {
        navigate("/composeemailmessagelist/");
    }
    const handleParamChange = (e) => {
        setEmployer(e.value)
console.log(e)
         setSelectedMessage((prev) => {
            return {
                ...prev,
                ["employer"]: e.value
            }
        })
    };
    const getMessage = async (id) => {
        getEmailMessage(id).then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    console.log(body.message[0])
                    setSelectedMessage(body.message[0])
                    setEmployer(body.message[0].employer)
                })
            }
            else {
                setErrorMessage(res.statusText)
            }
        })
    }


    const savemessage = async () => {
        const from = document.getElementById("from").value
        const to = document.getElementById("to").value
        const subject = document.getElementById("subject").value
        let id = document.getElementById("id").value
        const message = quill.getSemanticHTML()
       
        if (id === undefined || id.length === 0) {
            await saveEmailMessage(from, to, employer, subject, message).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        //console.log(body)
                        setSelectedMessage(body[0])
                         setMessage("Bericht [" + subject +"] bewaard")
                       return body[0].id
                    })
                }
                else {
                    setErrorMessage(res.statusText)
                }
           })
        } else {
           await  updateEmailMessage(from, to, employer, subject, message, id).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        //console.log(body[0])
                        setSelectedMessage(body[0])
                         setMessage("Bericht [" + subject +"] aangepast")
                         return body[0].id
                    })
                }
                else {
                    setErrorMessage(res.statusText)
                }
            })
        }
        
    }

    const SendMessage = async () => {
        //const idret = await savemessage()

        const from = document.getElementById("from").value
        const to = document.getElementById("to").value
        const subject = document.getElementById("subject").value
        const id = document.getElementById("id").value
        const message = quill.getSemanticHTML()
        //sendEmailMessage
        console.log("employer:", employer)
             console.log("to:", to)
              console.log("subject:", subject.length)
        if(employer !== 0 && to !== 0 && subject.length > 0)
        {
         const test = await sendEmailMessage(from, to, employer, subject, message, id).then(res => {
                if (res.status === 200) {
                     
                    res.json().then(body => {
                    setSelectedMessage(body.message[0])
                    setMessage("Bericht [" + subject +"] verzonden")
                       return body.message[0].id
                    })
                }
                else {
                    setErrorMessage(res.statusText)
                }
           })
        }else{
             setHTMLMessage("Sommige gegevens ontbreken <ul><li>Werkgever</li><li>To [BCC]</li><li>Titel</li></ul> gelieve deze eerst in te vullen alvorens te verzenden")
        }
    }

    const changevalue = (e) => {
        setSelectedMessage((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }

    return (
        <>
            <div id="main" className="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <br></br>
                            <center> <Button type="button" id="CloseMessageButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button> &nbsp;
                            </center>
                        </div>
                    </div>
                    {/* <div className="checkinTime"><div id="timelabel" ></div><div id="time"></div></div> */}
                </header>

                <div className="form">
                    <Button type="button" id="cancelButton" class="Savebutton btn btn-primary margin-right" onClick={navigateback} >{t('Naaroverzicht')}</Button>
                </div>
                <div id="return" className="form">
                    <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
                    <br></br>
                    <div className="contentbox ">
                        <div id="sendtobox" className="emailheader">
                            <div className="emailbutspan">
                                <div className='emailsendbut'>
                                    <VscSend className="emailsendicon" onClick={() => SendMessage()}  />
                                    <br></br>
                                    {t('Send')}
                                </div>
                                <div className='emailsavebut'>
                                    <AiOutlineSave className="emailsendicon" onClick={() => savemessage()} />
                                    <br></br>
                                    {t('Save')}

                                </div>
                            </div>
                            <label className='labelcolor'>
                                {t('id')}:
                            </label>
                            <input
                                id='id'
                                type='text'
                                className="email-control"
                                name='id'
                                value={selectedmessage.id}
                                disabled={true}
                            />
                            <label className='labelcolor'>
                                {t('From')}:
                            </label>
                            <input
                                id='from'
                                type='text'
                                className="email-control"
                                name='from'
                                value={selectedmessage.from === undefined ? user.email  : selectedmessage.from}
                                disabled={true}
                            />
                            <label className='labelcolor'>
                                {t('Employer')}:
                            </label>
                            <Select
                                id="employer"
                                onChange={e => handleParamChange(e)}
                                options={employersArray}
                                name="employer"
                                value={employersArray.find(opt => opt.value === selectedmessage.employer) || null}
                                placeholder={t('Kies een werkgever')}
                                isSearchable
                                className="email-control"
                            />
                            <label className='labelcolor'>
                                {t('To [BCC]')}:
                            </label>
                            <select className='email-control' id="to" name="to" value={selectedmessage.to} onChange={e => changevalue(e)}>
                                <option value={0}>test only</option>
                                <option value={-1}>Alle medewerkers</option>
                                <option value={3}>Supervisors</option>
                                <option value={1}>Cleaners</option>
                                <option value={2}>Administrators</option>
                                <option value={4}>Overhead</option>
                            </select>
                            <label className='labelcolor'>
                                {t('Subject')}:
                            </label>
                            <input className='email-control' type="text" id="subject" value={selectedmessage.subject}  name="subject" onChange={e => changevalue(e)}>
                            </input>

                        </div>
                    </div>
                    <br></br>
                    <div className="toolbox" >
                        <div ref={quillRef} id="message" className="rte" />
                    </div>
                </div>

            </div>
        </>
    )

}

export default Composeemailmessage